import React, { useState, useEffect, useRef, useContext } from "react";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import axios from "../../api/axios";
import Select from "react-select";
import { AuthContext } from "../../context/auth";
import Error403 from "../../components/Error/403";

const PurchaseIndexAdd = ({ loggedInUser }) => {
  const [formData, setFormData] = useState({
    purchase_id: "",
    vendor_id: "",
    price: "",
    total_amount: 0,
  });
  const [vendors, setVendors] = useState([]);
  const [blocks, setBlocks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [lastFivePurchases, setLastFivePurchases] = useState([]);
  const { user } = useContext(AuthContext);

  const fetchVendors = async () => {
    try {
      setLoading(true);
      const response = await axios.get("/get-all-vendor");
      setVendors(response.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching vendors:", error);
      setLoading(false);
    }
  };

  const fetchLastFivePurchases = async () => {
    try {
      const response = await axios.get("/get-purchase?page=1&itemsPerPage=5");
      setLastFivePurchases(response.data);
    } catch (error) {
      console.error("Error fetching last five purchases:", error);
    }
  };

  useEffect(() => {
    fetchVendors();
    fetchLastFivePurchases();
  }, []);

  if (user) {
    const access = user.user?.role.find((role) => role.name === "purchase");
    if (!access?.allow) {
      return <Error403 />;
    }
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });

    if (name === "price" || name === "quantity") {
      const updatedPrice = name === "price" ? value : formData.price;
      const updatedQuantity = name === "quantity" ? value : formData.quantity;
      setFormData((prevFormData) => ({
        ...prevFormData,
        total_amount: updatedPrice * updatedQuantity,
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios
        .post("/add-purchase", {
          ...formData,
          user_id: loggedInUser,
        })
        .then((r) => r.data);

      if (response.success) {
        toast.success("Purchase added successfully");
        fetchLastFivePurchases();
        setFormData({
          purchase_id: "",
          vendor_id: "",
          price: "",

          total_amount: 0,
        });
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.error("Error adding purchase:", error);
      toast.error("Failed to add purchase");
    }
  };

  return (
    <div className="container">
      <section className="content">
        <div className="row">
          <div className="col-md-6">
            <div className="card shadow p-3 mb-5 bg-body rounded">
              <div className="card-header">
                <h3 className="card-title">Add Purchase</h3>
              </div>
              <div className="card-body">
                <form onSubmit={handleSubmit}>
                  <div className="form-group">
                    <label htmlFor="purchase_id">Purchase ID</label>
                    <input
                      type="text"
                      className="form-control"
                      id="purchase_id"
                      name="purchase_id"
                      value={formData.purchase_id}
                      onChange={handleInputChange}
                      placeholder="Ex: 01-0001"
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="vendor_id">Vendor</label>
                    <Select
                      options={vendors.map((vendor) => ({
                        value: vendor._id,
                        label: vendor.vendor_name,
                      }))}
                      onChange={(selectedOption) =>
                        setFormData({
                          ...formData,
                          vendor_id: selectedOption.value,
                        })
                      }
                      placeholder="Select Vendor"
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="price">Price</label>
                    <input
                      type="number"
                      className="form-control"
                      id="price"
                      name="price"
                      value={formData.price}
                      onChange={handleInputChange}
                      placeholder="Ex: 500"
                      required
                    />
                  </div>

                  <button type="submit" className="btn btn-primary">
                    Add Purchase
                  </button>
                </form>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="card shadow p-3 mb-5 bg-body rounded">
              <div className="card-header">
                <h3 className="card-title">Last Five Purchases</h3>
              </div>
              <div className="card-body">
                <table className="table">
                  <thead>
                    <tr>
                      <th>Purchase ID</th>
                      <th>Vendor</th>
                      <th>Total Amount</th>
                      <th>Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {lastFivePurchases?.map((purchase) => (
                      <tr key={purchase.purchase_id}>
                        <td>{purchase.purchase_id}</td>
                        <td>{purchase.vendor_id?.vendor_name}</td>
                        <td>{purchase.price}</td>
                        <td>
                          {new Date(purchase.createdAt).toLocaleDateString()}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PurchaseIndexAdd;
